/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Fact_DivInputs */

const en_mk_sol_fact_div = /** @type {(inputs: Mk_Sol_Fact_DivInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active divisions`)
};

const id_mk_sol_fact_div = /** @type {(inputs: Mk_Sol_Fact_DivInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisi yang aktif`)
};

/**
* | output |
* | --- |
* | "Active divisions" |
*
* @param {Mk_Sol_Fact_DivInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_fact_div = /** @type {((inputs?: Mk_Sol_Fact_DivInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Fact_DivInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_fact_div(inputs)
	return en_mk_sol_fact_div(inputs)
});